import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import Auth from "src/service/Auth";

export const getCustomerScopeInformation = createAsyncThunk('auth_getCustomerScopeInformation', async () => {
    return await new Auth().getCustomerScopedInformation()
});

const slice = createSlice({
        name: "auth",
        initialState: {
            success: null,
            permissions: {},
            SET_SHIPPING_ADDRESS_LIST: [],
            CUSTOMER_INFORMATION: {}
        },
        reducers: {
            login: async (state, action) => {
                state.success = action.payload.success;
                return state;
            },
            SET_SHIPPING_ADDRESS_LIST: {
                reducer: (state, action) => {
                    state.SHIPPING_ADDRESS_LIST = action.payload.SHIPPING_ADDRESS_LIST;
                    return state;
                }
            },
            LOAD_ALL_ROLE_BASED_PERMISSIONS: {
                reducer: (state, action) => {
                    state.permissions = action.payload.permissions;
                    return state;
                }
            },
        },
        extraReducers: {
            [getCustomerScopeInformation.fulfilled]: (state, { payload }) => {
                state.CUSTOMER_INFORMATION = payload;
                return state;
            },
        }
    })
;

export let {login, SET_SHIPPING_ADDRESS_LIST, LOAD_ALL_ROLE_BASED_PERMISSIONS} = slice.actions;

export default slice.reducer;
